import { render, staticRenderFns } from "./expiry.vue?vue&type=template&id=4a574d0e"
import script from "./expiry.vue?vue&type=script&lang=js"
export * from "./expiry.vue?vue&type=script&lang=js"
import style0 from "./expiry.vue?vue&type=style&index=0&id=4a574d0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports